<template>
    <svg
        id="icon_lobby_gold"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="12"
            cy="12"
            r="12"
            fill="#ffdc7b"
        />
        <path
            id="Path_3"
            data-name="Path 3"
            d="M6.414,5.345A7.993,7.993,0,0,1,10.5,6.376l.657-1.936A7.515,7.515,0,0,0,7.194,3.3V.8H5.407V3.347C2.368,3.7.951,5.492.951,7.407c0,2.061,1.458,3.45,4.99,4.418,2.28.589,3.368,1.22,3.368,2.461,0,1.262-1.376,2.019-3.451,2.019A8.377,8.377,0,0,1,1.28,15.126L.622,17.062a8.359,8.359,0,0,0,4.683,1.3v2.419H7.091v-2.5c3.121-.379,4.642-2.272,4.642-4.165,0-2.357-1.295-3.514-4.7-4.46-2.649-.779-3.655-1.452-3.655-2.42C3.374,6.376,3.99,5.345,6.414,5.345Z"
            transform="translate(5.823 1.005)"
            fill="#854b97"
            fill-rule="evenodd"
        />
    </svg>
</template>
